import React, { Component } from 'react';
import { connect } from 'react-redux';
import Loading from '../../../../../common/loading/Loading';
import {
  fetchAllNotification,
  loadMoreNotification,
  REDUCER_NAME,
} from '../reducer';
import '../index.scss';
import NotificationHeader from './NotificationHeader';
import NotificationList from './NotificationList';
import Const from '../Const';

const { FUNDAMENTAL, TECHNICAL, EVENTS } = Const.NOTIFICATION_TYPES;

const PER_PAGE = 20;
const LAST_CLICK_BELL_ICON = 'LAST_CLICK_BELL_ICON';
const MAX_UNREAD = 9;

class Notification extends Component {
  state = {
    type: Const.NOTIFICATION_TYPES.FUNDAMENTAL,
    isShow: false,
    page: {
      [FUNDAMENTAL]: 1,
      [TECHNICAL]: 1,
      [EVENTS]: 1,
    },
  };
  listRef = React.createRef();
  bellRef = React.createRef();
  countRef = React.createRef();

  componentDidMount() {
    const { fetchAllNotification } = this.props;
    fetchAllNotification({
      Page: this.getCurrentPage(),
      PageSize: PER_PAGE,
    });
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const { isShow } = this.state;
    if (isShow && !prevState.isShow) {
      window.addEventListener('click', this.onWindowClick);
    }
  }

  componentWillUnmount() {
    window.removeEventListener('click', this.onWindowClick);
  }

  getCurrentPage = () => {
    const { type, page } = this.state;
    return page[type];
  };

  onWindowClick = e => {
    if (
      e.target === this.bellRef.current ||
      e.target === this.countRef.current
    ) {
      return;
    }
    if (this.listRef.current && !this.listRef.current.contains(e.target)) {
      this.setState({
        isShow: false,
      });
      window.removeEventListener('click', this.onWindowClick);
    }
  };

  changeType = type => {
    this.setState({
      type,
    });
  };

  toggleShow = () => {
    const { isShow } = this.state;
    if (!isShow) {
      const now = new Date().getTime();
      localStorage.setItem(LAST_CLICK_BELL_ICON, now.toString());
    }
    this.setState(prevState => ({
      isShow: !prevState.isShow,
    }));
  };

  isLoadMore = e => {
    const { type } = this.state;
    const { notificationLimit } = this.props;
    const isBottom =
      e.target.scrollHeight - Math.round(e.target.scrollTop) ===
      e.target.clientHeight;
    const isNotLastPage =
      Math.ceil(notificationLimit[type] / PER_PAGE) > this.getCurrentPage();

    return isBottom && isNotLastPage;
  };

  onScroll = e => {
    const { type, page } = this.state;
    const { loadMoreNotification } = this.props;
    if (this.isLoadMore(e)) {
      const nextPage = this.getCurrentPage() + 1;
      this.setState(
        {
          page: {
            ...page,
            [type]: nextPage,
          },
        },
        () => {
          loadMoreNotification({
            Page: nextPage,
            PageSize: PER_PAGE,
            AlertType: type,
          });
        },
      );
    }
  };

  renderListNotification = () => {
    const { isShow, type } = this.state;
    const { isLoading } = this.props;
    if (!isShow) {
      return null;
    }

    return (
      <ul ref={this.listRef} className="notifications dropdown-nav caret">
        {isLoading && <Loading />}
        <div className={isLoading ? 'bg-blur' : ''}>
          <NotificationHeader
            toggleShow={this.toggleShow}
            type={type}
            changeType={this.changeType}
          />

          <NotificationList onScroll={this.onScroll} type={type} />
        </div>
      </ul>
    );
  };

  getCountUnReadNotification = () => {
    const { notification } = this.props;
    const lastClick = +localStorage.getItem(LAST_CLICK_BELL_ICON);
    const getFinalUnread = count =>
      count > MAX_UNREAD ? `${MAX_UNREAD}+` : count;
    try {
      const allNotifications = [
        ...notification[FUNDAMENTAL],
        ...notification[TECHNICAL],
        ...notification[EVENTS],
      ];
      if (!lastClick) {
        return getFinalUnread(allNotifications.length);
      }
      const unReads = allNotifications.reduce((total, item) => {
        const createDate = new Date(item.createDate).getTime();
        if (createDate > lastClick) {
          return total + 1;
        }
        return total;
      }, 0);

      return getFinalUnread(unReads);
    } catch (e) {
      return null;
    }
  };

  render() {
    const countUnread = this.getCountUnReadNotification();

    return (
      <div className="fiidropdown right notifi-all ml-6">
        <a
          onClick={this.toggleShow}
          className="bor-ts-color-2 position-relative"
        >
          <span className="bg-bor-sp">
            <i ref={this.bellRef} className="icon-bell" />
            <span className="notifi-dot" />
          </span>
          <div
            style={{
              display: countUnread ? 'flex' : 'none',
            }}
            ref={this.countRef}
            className="notification-count"
          >
            {countUnread}
          </div>
        </a>
        {this.renderListNotification()}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  isLoading: state[REDUCER_NAME].isNotificationLoading,
  locale: state.i18n.locale,
  notificationLimit: state[REDUCER_NAME].notificationLimit,
  notification: state[REDUCER_NAME].notification,
});

const mapDispatchToProps = {
  fetchAllNotification,
  loadMoreNotification,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Notification);
